import { render } from "./Steps1.vue?vue&type=template&id=23038f81"
import script from "./Steps1.vue?vue&type=script&lang=js"
export * from "./Steps1.vue?vue&type=script&lang=js"
script.render = render

export default script